import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  isConnected: boolean;
  onConnect: () => void;
  onDisconnect: () => void;
};

export function ConnectionButton({ isConnected, onConnect, onDisconnect }: Props) {
  const { t } = useTranslation();

  return !isConnected ? (
    <button
      type='button'
      onClick={onConnect}
      className='px-3 py-1.5 border border-blue-500 dark:border-[#FFDA68] text-blue-500 dark:text-[#FFDA68] text-sm leading-5 font-semibold rounded-xl transition-colors hover:bg-blue-500 dark:hover:bg-[#FFDA68] hover:text-white dark:hover:text-[#151515]'
    >
      {t('Connect')}
    </button>
  ) : (
    <button
      type='button'
      onClick={onDisconnect}
      className='px-3 py-1.5 border border-gray-500 dark:border-none text-gray-500 dark:text-[#151515] text-sm leading-5 font-semibold rounded-xl transition-colors hover:bg-blue-500 hover:text-white bg-white dark:bg-[#FFDA68]'
    >
      {t('Disconnect')}
    </button>
  );
}
